export const COURSE_TYPES = {
  REQUEST: "REQUEST",
};

export const ROUTES = {
  // public
  ROOT: "/",
  LOGIN: "/login",
  LOGIN_OLD: "/login-to-telematic-university",
  PAGE: "/page",
  REGISTER: "/register",
  PASSWORD_RESET: "/password-reset",
  PASSWORD_RESET_TOKEN: "/password-reset-token",
  PASSWORD_RESET_UNTOKEN: "/password-reset-untoken",
  PRIVACY_POLICY: "/page/privacy-policy",
  INFORMATIVA: "/page/informativa-dati-personali",
  PAGE_SUPPORT: "/supporto-tecnico",
  WORK_WITH_US: "/page/lavora-con-noi",

  PRIVACY_POLICY_REV2022: "/page/privacy-policy",
  COOKIE_POLICY_REV2022: "/page/cookie-policy",
  PRINCIPI_ETICI_REV2022: "/page/principi-etici",
  INFORMATIVA_REV2022: "/page/informativa-dati-personali",

  PAGE_WHOARE_OLD: "/page/chi-siamo",
  PAGE_WHOARE_OLD2: "/associazione-mnemosine",
  PAGE_WHOARE: "/chi-siamo",
  PAGE_404: "/404",

  COURSE_BROWSE_OLD: "/corsi-online",
  COURSE_BROWSE: "/corsi-mnemosine",
  COURSE_BROWSE_60CFU: "/percorsi-abilitanti-insegnanti-60-30-36-cfu",
  COURSE_BROWSE_3036CFU:
    "/percorsi-abilitanti-insegnanti-vincitori-concorso-30-36-cfu",
  COURSE_BROWSE_PERCORSI_ABILITANTI:
    "/percorsi-abilitanti-insegnanti-60-30-36-cfu-2026",
  COURSE_INFO_PERCORSI_ABILITANTI:
    "/dettaglio-percorsi-abilitanti-insegnanti-60-30-36-cfu-2026",

  BANDO_INFO_BROWSER:
    "/bandi/consultazione-graduatorie-percorsi-abilitanti-60-30-cfu",

  COURSE_BROWSE_ABILITAZIONI_60CFU:
    "/adesione-percorsi-abilitanti-insegnanti-60-30-36-cfu",
  COURSE_SSD_BROWSE_OLD: "/trova-master-ssd",
  COURSE_SSD_BROWSE: "/corsi-mnemosine/master-universitari",
  COURSE_MUPA_BROWSE: "/corsi-mnemosine/mupa",
  MASTER_MEDICINA_LIST: "/master-medicina",
  MASTER_MEDICINA_DETAIL: "/master-medicina-dettaglio",
  COURSE_LANDINGPAGE: "/corso-online",
  COURSE_LANDINGPAGE_FULL: "/corso-online-mnemosine",
  COURSE_LANDINGPAGE_HS: "/corso-online-hs",
  COURSE_FULLLAYOUTPAGE: "/corso-online-formazione",
  COURSE_LANDINGPAGE_IFRAME: "/iscrizione-iframe",

  COURSE_SURVEY_MAIN: "/indagine-conoscitiva",

  // blog
  BLOG_HOME: "/mnemosine-news",
  BLOG_ARTICLE: "/mnemosine",

  // social
  SOCIAL_HOME: "/mnemosine-social",
  SOCIAL_ARTICLE: "/mnemosine-social-article",

  // public promo
  PROMO_AMICI: "/promo-amici",
  PROMO_FAMIGLIA: "/promo-famiglia",
  PROMO_ISTITUTO: "/promo-istituto",
  PROMO_CORSO_GRATUITO: "/progetto-corso-gratuito",
  PROMO_TABLET: "/tablet-omaggio",
  PROMO_50: "/promo-50",

  //public Regolamento
  PAGE_RULE: "/regolamento",

  //public impegno e solidarietà
  PAGE_SOLIDARITY: "/solidarieta",
  PAGE_SOLIDARITY_2: "/solidarieta-mnemosine-per-il-sociale",
  PAGE_LEONI_SICANI: "/associazione-a-s-d-leoni-sicani",
  PAGE_UNICEF: "/unicef-istruzione-per-i-bambini-colpiti-dalla-crisi-in-siria",

  //public 24cfu
  PAGE_CONCESSIONS: "/contratto-collettivo-nazionale-integrativo",
  PAGE_BENEFITSC24: "/vantaggi-corsi-24cfu",
  PAGE_BENEFITSM24: "/vantaggi-master-24cfu",
  PAGE_REFERENCELEGISLATION: "/24-cfu-accesso",
  //PAGE_REQUESTCERTIFICATION: '/riconoscimenti-cfu',

  //public clil
  PAGE_BENEFITSCLIL: "/clil-agevolazioni",

  //public ATA
  PAGE_ACCESSTITLEATA: "/titoli-accesso-ai-profili-ata",

  //public perfezionamento PLU - PDU
  PAGE_PERFEZIONAMENTOPDUPLU: "/post-laurea-post-diploma",

  //public indire
  PAGE_TFAINDIRE: "/tfa-indire",

  //public  CSU - RCSU
  PAGE_CORSISINGOLICSURCSU: "/corsi-singoli-universitari",

  //public perfezionamento MUPA - MSLU
  PAGE_MASTERMUPAMSLU: "/master-pubblica-amministrazione",

  //public tfa indire
  PAGE_TFAINDIREESTEROTRIENNALISTI: "/tfa-indire-estero-triennalisti",

  //public English
  PAGE_ENGLISHCERTIFICATION: "/certificazione-lingua-inglese-b2-c1",

  //public Bonus carta docente
  PAGE_TEACHERCARD: "/come-generare-il-bonus-scuola-per-i-corsi-mnemosine",

  //public Dottorato
  PAGE_DOCTORATE: "/dottorati-di-ricerca",

  //public Gsuite details
  PAGE_GSUITEDETAILS: "/dettaglio-corso-google",

  //public 24cfu details
  PAGE_24CFUDETAILS: "/U24CFU",

  //public 5cfu insight
  PAGE_5CFUINSIGHT: "/approfondimenti-5cfu",
  PAGE_DECRETOMINISTERIALE108: "/decreto-ministeriale-n-108",

  //public page
  PAGE_NEWSCANCEL: "/newscancel",

  // my
  DASHBOARD: "/dashboard",
  DASHBOARD_SEGRETERIA_IUL: "/dashboard-segreteria-iul",
  DASHBOARD_STEWARD: "/dashboard-steward",

  MY_PROFILE: "/my/profile",
  MY_ENROLLMENT: "/my/enrollment",
  MY_ENROLLMENT_PENDING: "/my/enrollment-pending",
  MY_ENROLLMENT_PREREQUISITES: "/my/enrollment-prerequisites",
  PAYMENT_RESULT_OK: "/bankpayment-result/ok",
  PAYMENT_RESULT_KO: "/bankpayment-result/ko",
  PAYMENT_RESULT_NOTIFY: "/bankpayment-notify",
  PAYMENT_GOMP_RESULT_NOTIFY: "/pagopa-notify",
  MY_QUALIFICATION: "/my/qualifications",
  MY_DOCUMENT: "/my/document",
  MY_INVOICEDATA: "/my/invoice-data",
  MY_QUIZREVIEW: "/my/quizreview",
  MY_BADGE: "/my/badge",

  // course
  COURSE_DASHBOARD: "/course/dashboard",
  COURSE_LIST: "/course/list",
  IUL_COURSE_LIST_ONLINE: "/course-iul/list-online",
  IUL_COURSE_LIST_ONSITE: "/course-iul/list-onsite",
  IUL_COURSE_LIST_TRAINING: "/course-iul/list-training",
  IUL_COURSE_LIST_STUDENT: "/course-iul/list-by-studente",
  COURSE_TICKETS: "/course/tickets",
  COURSE_PAYMENTS: "/course/payments",
  COURSE_INVOICES: "/course/invoices",
  COURSE_TICKET_DETAIL: "/course/ticket",
  COURSE_PAYMENT_CD: "/course/payment/carta_del_docente",
  COURSE_TITLE_SELF_DECLARATION: "/course/title-self-declaratio",
  COURSE_BOOKING_CLASS: "/course/booking-class",

  COURSE_LESSONSECTION_SCHEDULE: "/course/lesson-section/schedule",
  COURSE_LESSONSECTIONGROUP_SCHEDULE: "/course/lesson-section/groupschedule",
  COURSE_LESSONLIVE_SCHEDULE_ONLINE: "/course/live-lesson/schedule",
  COURSE_LESSONLIVE_SCHEDULE_ONLINE_ALL: "/course/live-lesson-all/schedule",
  COURSE_LESSON_SCHEDULE_ALL: "/course/lesson/schedule-all",
  COURSE_LESSONLIVE_MATERIALS: "/course/live-lesson/materials",
  COURSE_LESSONLIVE_SCHEDULE_OFFLINE: "/course/live-lesson/schedule-offline",
  COURSE_LESSONTRAINING_SCHEDULE: "/course/training-lesson/schedule",
  COURSE_LESSONTRAINING_DETAIL: "/course/training-lesson/detail",
  COURSE_TIROCINIODIRETTO_DETAIL: "/course/tirocinio-diretto/detail",
  COURSE_TIROCINIODIRETTOTFACLASSICO_DETAIL: "/course/tirocinio-diretto/tfa-classico/detail",
  COURSE_MODULES_TFACLASSICO: "/course/modules/tfa-classico",

  COURSE_LESSONONSITE_SCHEDULE: "/course/onsite-lesson/schedule",
  COURSE_LESSONONSITE_DETAIL: "/course/onsite-lesson/detail",
  COURSE_LESSON_ACTIVITY: "/course/lesson-activity",

  COURSE_LESSONLIVE_DETAIL: "/course/live-lesson/detail",
  COURSE_LESSONLIVE_CONFIRM_REGISTRATION:
    "/course/live-lesson/confirm-registration",
  COURSE_SHOW_FILE: "/course/show-file",

  COURSE_CFU60ALL1_UDA_EXAMWRITTEN: "/course/60cfuall1-examwritten",
  COURSE_CFU30ALL2_UDA_EXAMWRITTEN: "/course/30cfuall2-examwritten",
  COURSE_TFAINDIRE_EXAMWRITTEN: "/course/tfaindire-examwritten",

  COURSE_RC30_EXAM_RESERVATION: "/course/rc30-exam-reservation",
  COURSE_RC30_EXAM_SUBJECT: "/course/rc30-exam-subject",
  COURSE_RC30_CERT_REQUEST: "/course/rc30-cert-request",
  COURSE_RC30_CONFIRM_EXAMSITE: "/course/rc30-confirm-examsite",
  COURSE_RC30_UDA_EXAMWRITTEN: "/course/rc30-examwritten",

  COURSE_RC60CFUALL1_EXAM_SUBJECT: "/course/rc60cfuall1-exam-subject",
  COURSE_RC60CFUALL1_CERT_REQUEST: "/course/rc30-cert-request",

  COURSE_RC30CFUALL2_EXAM_SUBJECT: "/course/rc30cfuall2-exam-subject",
  COURSE_RC30CFUALL2_CERT_REQUEST: "/course/rc30-cert-request",

  COURSE_EXAM_WRITTEN_RESERVATION: "/course/exam-written-reservation",
  COURSE_EXAMFINAL_ONSITE_RESERVATION:
    "/course/exam-written-onsite-reservation",
  COURSE_EXAMINSEGNAMENTI_RESERVATION:
    "/course/exam-tfaindire-insegnamenti-reservation",
  COURSE_EXAMLABORATORI_RESERVATION:
    "/course/exam-tfaindire-laboratori-reservation",
  COURSE_EXAMFINALINDIRE_RESERVATION:
    "/course/exam-final-tfaindire-reservation",
  COURSE_EXAM_LIVE_RESERVATION: "/course/exam-live-reservation",
  COURSE_EXAM_DONE: "/course/exam-done",
  COURSE_DOCS: "/course/docs",
  COURSE_ISTRUCTION: "/course/istruction",
  COURSE_TUTOR: "/course/tutor",
  COURSE_PROVIDER: "/course/provider",
  COURSE_TITLE_REQUEST: "/course/title-request",
  PERFEZIONAMENTO_EXAM_WRITTEN: "/course/perfezionamento-exam-written",
  PERFEZIONAMENTO_EXAM_LIVE: "/course/perfezionamento-exam-live",

  // learning
  LEARNING_MAIN: "/learning/courseMain",
  LEARNING_LESSON: "/learning/lesson",
  LEARNING_FINAL_PAPER: "/learning/final-paper",
  LEARNING_QUIZ_MAIN: "/learning/quizMain",
  LEARNING_QUIZ_FEEDBACK: "/learning/quiz-feedback-final",

  // MU
  MU_COURSE_PAYMENTS: "/course/mu-payments",
  MU_COURSE_DOCS: "/course/mu-docs",
  MU_SELF_DECLARATION: "/course/mu-self-declaration",
  MU_COURSE_TITLE_REQUEST: "/course/mu-title-request",
  MU_C24_CERT_REQUEST: "/course/mu-c24-cert-request",
  MU_UM_TITLE_DONWLOAD: "/course/mu-mu-title-download",

  MU_PAYMENT_REQUEST: "/course/mu-paymentother-request",

  // M24
  M24_LESSON: "/learning/m24-lesson",

  // UCSU
  UCSU_LESSON: "/learning/ucsu-lesson",
  USCU_CERT_REQUEST: "/course/uscu-cert-request",

  // RCSU
  RCSU_LESSON: "/learning/rcsu-lesson",

  // MNE
  MNE_SIMULATION_EXAM: "/learning/mne-simulation-exam",

  // C24
  C24_EXAMWRITTEN_RESERVATION: "/course/c24-examwritten-reservartion",
  C24_EXAMWRITTEN_ONSITE_RESERVATION:
    "/course/c24-examwritten-onsite-reservartion",
  C24_EXAMLIVE_RESERVATION: "/course/c24-examlive-reservartion",
  C24_EXAMWRITTEN: "/course/c24-exam-written",
  C24_CERT_REQUEST: "/course/c24-cert-request",

  C24_EXAMLIVE: "/course/c24-examlive",

  COURSE_CFU_SELF_DECLARATION: "/course/cfu-self-declaration",

  //GOOGLE_MEET: '/meet-google',

  // ICDL
  ICDL_LESSON: "/learning/icdl-lesson",
  ICDL_CERTIFICATION: "/course/icdl-certification",
  ICDL_EXAM_RESERVATION: "/course/icdl-exam-reservartion",

  //DIGCOMP
  DIGCOMP_LESSON: "/learning/digcomp-lesson",

  COURSE_MANIFESTO: "/course/manifesto",

  // CV
  CV_DOCS: "/course/cv-docs",

  // ESB
  ESB_LESSON: "/learning/esb-lesson",
  ESB_EXAM_RESERVATION: "/course/esb-exam-reservartion",

  //MNE
  COURSE_TUTOR_MNE: "/course/tutor-mne",
  ASSISTANCE_TELEPHONE_MNE: "/course/assistance-telephone-mne",
  ASSISTANCE_ONLINE_MNE: "/course/assistance-online-mne",

  // tools
  MOBILE_CONFIRM: "/tools/mobile-confirm",

  // services
  QUALIFICATION_EVALUATION: "/valutazione-titoli",
  QUALIFICATION_MAP: "/corrispondenza-titoli",
  TITLE_DELIVERY: "/prenotazione-ritiro-titoli",
  TITLE_DELIVERY_ESB: "/prenotazione-ritiro-titoli-inglese",

  // agenda
  AGENDA: "/agenda",

  // career
  CAREER: "/career",
  CONFIRM: "/confirm/:key",

  //steward
  STEWARD_VERIFY_IDENTITY: "/steward-verify-identity",
  STEWARD_VERIFY_ATTENDANCE: "/steward-verify-attendance",
  STEWARD_VERIFY_IDENTITY_LESSONONSITE: "/steward-verify-identity-onsite",
  STEWARD_VERIFY_IDENTITY_LESSONTRAINING: "/steward-verify-identity-training",
  STEWARD_LESSON_TODAY: "/steward-lesson-today",

  // admin
  COURSE_MANAGER: "/course-manager",
  COURSE_TYPE_MANAGER: "/course-type-manager",
  COURSE_FORM: "/course-form",
  COURSE_TYPE_FORM: "/course-type-form",
  LESSON_FORM: "/lesson-form",
  QUIZ_FORM: "/quiz-form",
  EXAMPLES: "/examples",
  USER_LIST: "/users",
  REVISOR_DETAIL: "/revisor/detail",
  COURSE_REPOQUIZ_MANAGER: "/repoquiz",
  REPOQUIZ_FORM: "/repoquiz-form",
  REPOQUIZ_IMPORT: "/repoquiz-import",
  PROMOTIONAL_MANAGER: "/promotional-manager",
  PROMOTIONAL_FORM: "/promotional-form",
  USER_SYNC_IN: "/user/syncin",
  SITECONFIG_MANAGER: "/siteconfig-manager",
  SITECONFIG_FORM: "/siteconfig-form",
  LESSON_STUDENT_SCHEDULE: "/lesson-student-schedule",

  LESSON_LIVE_SCHEDULE: "/lessonlive-schedule",
  LESSON_LIVE_SCHEDULE_FORM: "/lessonlive-schedule-form",
  LESSON_STUDENT_ANALYTICS: "/lesson-student-analytics",
  LESSON_LIVE_SCHEDULE_ANALYTICS: "/lessonlive-analytics",
  LESSON_LIVE_PROCESS_ANALYTICS: "/lessonlive-analytics-process",
  LESSON_PROCESS_ANALYTICS_TFA_INDIRE: "/lessonlive-analytics-process-tfa-indire",
  LESSON_PROCESS_ANALYTICS_TFA_CLASSICO: "/lessonlive-analytics-process-tfa-classico",
  LESSON_LIVE_PROCESS_ANALYTICS_VC: "/lessonlive-analytics-process-vc",
  LESSON_LIVE_PROCESS_ANALYTICS_VC_SECIONTGROUP:
    "/lessonlive-analytics-process-vc-section-group",

  LESSON_LIVE_CLASS: "/lessonlive-class",
  LESSON_LIVE_CLASS_FORM: "/lessonlive-class-form",
  LESSON_LIVE_EDITION: "/lessonlive-edition",
  LESSON_LIVE_EDITION_FORM: "/lessonlive-edition-form",
  LESSON_LIVE_CALENDAR_WEBEX: "/lessonlive-calendar-webex",
  LESSON_LIVE_CLASS_UPLOAD_CALENDAR: "/lessonlive-class-upload-calendar",
  LESSON_LIVE_CLASS_MATERIAL: "/lessonlive-class-material",
  LESSON_LIVE_CLASS_MATERIAL_DETAIL: "/lessonlive-class-material-detail",

  LESSON_ONSITE_SCHEDULE: "/lessononsite-schedule",
  LESSON_ONSITE_SCHEDULE_FORM: "/lessononsite-schedule-form",
  LESSON_ONSITE_CLASS_BADGE: "/lessononsite-class-badge",

  TRAINING_SCHEDULE: "/training-schedule",
  TRAINING_SCHEDULE_FORM: "/training-schedule-form",
  TRAINING_SCHEDULE_ANALYTICS: "/training-analytics",
  TRAINING_CALENDAR_WEBEX: "/training-calendar-webex",

  LESSON_LIVE_ACCESS_ANOMALY: "/lessonlive-access-anomaly",
  LESSON_TRAINING_ACCESS_ANOMALY: "/lessontraining-access-anomaly",

  PAGE_CONTACT: "/contatti",
  PAGE_CONTACT_REQUEST: "/richiesta-contatto",
  PAGE_CONTACT_INFO: "/raggiungere-sede",

  BLOG_CATEGORY_MANAGER: "/cms/blog-category",
  BLOG_CATEGORY_FORM: "/cms/blog-category-form",
  BLOG_ARTICLE_MANAGER: "/cms/blog-article",
  BLOG_ARTICLE_FORM: "/cms/blog-article-form",

  NEWSLETTER_SUBSCRIBERS: "/cms/newsletter-subscribers",
  NEWSLETTER_EMAILS: "/cms/newsletter-emails",
  NEWSLETTER_EMAIL_DETAIL: "/cms/newsletter-detail",
  NEWSLETTER_EMAIL_FORM: "/cms/newsletter-email-form",

  LIBRARY_CATEGORY_MANAGER: "/cms/library-category",
  LIBRARY_CATEGORY_FORM: "/cms/library-category-form",
  LIBRARY_BOOK_MANAGER: "/cms/library-book",
  LIBRARY_BOOK_FORM: "/cms/library-book-form",
  LIBRARY_AUTHOR_MANAGER: "/cms/library-author",
  LIBRARY_AUTHOR_FORM: "/cms/library-author-form",

  PAGE_MANAGER: "/cms/page-list",
  PAGE_FORM: "/cms/page-form",

  PAGE_BIBLIOTECA: "/biblioteca",
  PAGE_CORSIDILAUREA: "/corsi-di-laurea",
  PAGE_SEDI_ESAMI: "/sedi-esami",

  SURVEY_MANAGER: "/cms/survey-list",
  SURVEY_FORM: "/cms/survey-form",

  QUALIFICATION_DATA_ANS_MANAGER: "/cms/ans-manager",

  ASSETS_AUDIO_CATEGORY_MANAGER: "/cms/assets-audio-category",
  ASSETS_AUDIO_CATEGORY_FORM: "/cms/assets-audio-category-form",
  ASSETS_AUDIO_FILE_MANAGER: "/cms/assets-audio-file",
  ASSETS_AUDIO_FILE_FORM: "/cms/assets-audio-file-form",

  CURRENT_REVISION: "/current-revision",
  HISTORY_REVISION: "/history-revision",
  PENDING_REVISION: "/pending-revision",
  PENDING_REVISION_ADMIN_30CFU: "/pending-revision-30cfu",
  VIEWER_UDA: "/viewer-uda",

  CURRENT_REVISION_LESSON_ACTIVITY: "/lesson-activity/current-revision",
  HISTORY_REVISION_LESSON_ACTIVITY: "/lesson-activity/history-revision",
  PENDING_REVISION_LESSON_ACTIVITY: "/lesson-activity/pending-revision",
  CURRENT_REVISION_LESSON_ACTIVITY_DETAIL: "/lesson-activity/revision-detail",
  CURRENT_REVISION_SECURITY: "/lesson-activity/security/current-revision",
  HISTORY_REVISION_SECURITY: "/lesson-activity/security/history-revision",
  PENDING_REVISION_SECURITY: "/lesson-activity/security/pending-revision",
  CURRENT_REVISION_SECURITY_DETAIL: "/lesson-activity/security/revision-detail",
  LESSON_ACTIVITY_ARCHIVE: "/lesson-activity-archive",
  LESSON_ACTIVITY_ARCHIVE_FORM: "/lesson-activity-archive-form",

  CURRENT_REVISION_LESSON_ACTIVITY_COMPANY: "/lesson-activity-company/current-revision",
  HISTORY_REVISION_LESSON_ACTIVITY_COMPANY: "/lesson-activity-company/history-revision",
  PENDING_REVISION_LESSON_ACTIVITY_COMPANY: "/lesson-activity-company/pending-revision",
  SECURITY_CERTIFICATES_LESSON_ACTIVITY_COMPANY: "/lesson-activity-company/security-certificates",
  CURRENT_REVISION_LESSON_ACTIVITY_COMPANY_DETAIL: "/lesson-activity-company/revision-detail",

  QUIZREVIEW_FORM: "/quizreview-form",
  EXAMREVIEW_FORM: "/examreview-form",

  CONTACT_REQUEST: "/contact-request",

  ACTIONS_OVER_DB: "/cms/dbactions",

  //--- ---

  ADESIONI_5CFU: "/adesioni-5cfu",
  ADESIONI_60CFU: "/adesioni-percorsi-abilitanti-insegnanti-30-36-60cfu",
  ADESIONI_MASTER_UNICAMILLUS: "/adesioni-master-medicina-unicamillus",

  FORM_TFA_SOSTEGNO_ESTERO: "/adesioni-tfa-sostegno-estero",
  FORM_TFA_SOSTEGNO_TRIENNALISTI: "/adesioni-tfa-sostegno-triennalisti",
  FORM_30CFU_UNICAMILLUS: "/30cfu-unicamillus",
  FORM_60CFU: "/60cfu-30cfu-abilitazione-insegnamento",
  ENROLL_30CFU: "/30cfu",
  ENROLL_TFA_IX_CICLO: "/tfa",
  ENROLL_TFA_IX_CICLO_TEMP: "/tfa-iscrizioni-temporanea",
  FORM_60CFU_EMBEDDED: "/60cfu-30cfu-embedded",

  ANALYSIS_USEREVALUATIONS_REPORT: "/analysis/userevaluation-report",
  ANALYSIS_SUMMARY_REPORT: "/analysis/summary-report",
  BANDO_EVALUATION_LOG: "/bandi/bando-evaluation-log",

  ANALYSIS_USEREVALUATIONS_REPORT_INDIRE:
    "/indire/analysis/userevaluation-report",
  BANDO_EVALUATION_LOG_INDIRE: "/indire/bandi/bando-evaluation-log",

  //----
  USER_SELF_DECLARATION: "/course/user-self-declaration",

  CFUALL_EXAM_RESERVATION: "/course/cfuall-exam-reservartion",

  ABILITAZIONE3060_ENROLLMENT_RESULT: "/course/abilitazione-enrollment-result",

  IMPORT_FROM_GOMP: "/import-from-gomp",
  IMPORT_FROM_GOMP_CLASSIC: "/import-from-gomp-classic",
  IMPORT_FROM_CONTINGENTE: "/import-contingente",
  IMPORT_FROM_RECOGNITION: "/import-riconoscimenti",
};

export const LESSON_TYPE = {
  LESSON_LIVE: "lessonLive",
  LESSON_ONSITE: "lessonOnSite",
  LESSON_TRAINING: "lessonTraining",
};

export const LESSONTRAINING_MODE = {
  ONLINE: "online",
  PRESENZA: "presenza",
  ATTIVITA: "attivita",
};

export const STRINGS = {
  TITLE: "Corsi Mnemosine",
  COMPANY: "Associazione Mnemosine",
};

export const CACHE_KEYS = {
  SESSION: "session",
  SESSION_REGION: "sessionRegion",
};

export const USER_QUALIFICATIONS = {
  DIPLOMA: "diploma",
  LAUREA: "laurea",
  IMMATRICOLAZIONE: "immatricolazione",
};

export const QUIZ_QUESTION_RENDER_MODE = [
  { value: "classic", label: "Classico" },
  { value: "fillFree", label: "a Completamento libero (auto correzione)" },
  {
    value: "fillFreeMulti",
    label: "a Completamento libero Multiplo (auto correzione)",
  },
  {
    value: "fillFromSelect",
    label: "a Completamento da Select (solo 1 è vera)",
  },
  {
    value: "audioToReview",
    label: "registrazione audio (per revisione)",
  },
  {
    value: "audioNoStored",
    label: "registrazione audio (da non salvare)",
  },
];

export const ADDRESS_TYPES = {
  BORN: "bornAddressId",
  DELIVERY: "deliveryAddressId",
  RESIDENCE: "addressId",
};

export const ADDRESS_TYPES_ACCESSORS = {
  [ADDRESS_TYPES.RESIDENCE]: "residenceAddress",
  [ADDRESS_TYPES.BORN]: "bornAddress",
  [ADDRESS_TYPES.DELIVERY]: "deliveryAddress",
};

export const GENDERS = [
  { value: null, label: "-" },
  { value: "m", label: "M" },
  { value: "f", label: "F" },
];

export const REVISOR_CONTEXTS = {
  ENGLISH: "english",
  ART13: "30cfu_art13",
  ABILITAZIONE30: "abilitazione30",
  ABILITAZIONE60: "abilitazione60",
  TIROCINIODIRETTO: "lessonActivity",
  TIROCINIODIRETTOCOMPANY: "lessonActivityCompany",
  TFAINDIRE: "tfa_indire",
};

export const LESSON_ACTIVITY_TYPES = {
  INDIRE: "indire",
  ABILITAZIONI: "tirociniodiretto",
  TFA_INDIRE: "tirociniodirettoindire",
  TFA_CLASSICO: "tirociniodirettotfaclassico",
};

export const TD_IDLESSON = {
  unicamillus: 314,
  unitelma: 315,
  reggio: 316,
};

export const DOC_TYPES = [
  { value: null, label: "Tipo di documento" },
  { value: "identityCard", label: "Carta d'identità" },
  { value: "drivingLicence", label: "Patente di guida" },
  { value: "passport", label: "Passaporto" },
];

export const DOC_TYPES_MAP = {
  identityCard: "Carta d'identità",
  drivingLicence: "Patente di guida",
  passport: "Passaporto",
};

export const VIEWS = {
  LEARNING: "Learning",
  MY: "My",
  COURSE: "Course",
  CAREER: "Career",
  AGENDA: "Agenda",
  PAGE: "Page",
};

export const STATUS_CODES = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTH: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE: 422,
  INTERNAL_ERROR: 500,
};

export const ENROLLMENT_STEPS = {
  START: "start",
  FILL: "fill",
  FILL2: "fill2",
  FILL3: "fill3",
  SIGN: "sign",
  PAY: "pay",
  END: "end",
  VIRTUALSTAMP: "virtualstamp",
};

export const TITLEREQUEST_STEPS = {
  START: "start",
  SIGN: "sign",
  PAY: "pay",
  DOWNLOAD: "download",
};

export const COMPANY = {
  SRL: "srl",
  ASSOCIAZIONE: "associazione",
  UNICAMILLUS: "unicamillus",
  UNITELMA: "unitelma",
  REGGIO: "reggio",
  TCHAIKOVSKY: "tchaikovsky",
  IUL: "iul",
};

export const PAYMENT_TYPES = {
  BONIFICO: "Bonifico",
  CARTA_DI_CREDITO: "Carta di credito",
  CARTA_DEL_DOCENTE: "Carta del docente",
  PAGOPA: "PagoPA",
  MAV: "MAV",
};

export const PAYMENT_STATUS = {
  STARTED: "started",
  APPROVED: "approved",
  SELFAPPROVED: "selfApproved",
  TOAPPROVE: "toApprove",
  ANNULLED: "annulled",
  REJECTED: "rejected",
};

export const PAYMENT_STATUS_LABEL = {
  started: "da completare",
  approved: "approvato",
  selfApproved: "approvato",
  toApprove: "da approvare",
  annulled: "annullato",
  rejected: "rifiutato",
};

export const WORKINGSTATUS = [
  { value: null, label: "-" },
  { value: "precario", label: "Precario" },
  { value: "non docente", label: "non Docente" },
  { value: "tempo indeterminato", label: "tempo Indeterminato" },
];

export const RESULTQUIZ = [
  { value: "", label: "selezionare" },
  { value: "superato", label: "superato" },
  { value: "non superato", label: "non superato" },
];

export const EXAMVOTE_30CFU = [
  { value: "", label: "selezionare" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "non idoneo", label: "non idoneo" },
];

export const EXAMVOTE_TFA_INDIRE = [
  { value: "", label: "selezionare" },
  { value: "idoneo", label: "idoneo" },
  { value: "non idoneo", label: "non idoneo" },
];

export const TAG_AREA = {
  AR: "Artistica",
  SG: "Storico Geografica",
  SC: "Scientifica",
  TE: "Tecnico Pratica",
  GE: "Giuridico Economica",
  EC: "Economica",
  EM: "Educazione Motoria",
  UM: "Umanistica",
  PS: "Psicomotoria",
  LI: "Linguistica",
  AM: "Artistico Musicale",
  TR: "Trasversale",
  GI: "Giuridica",
};

export const RCALL_EDITION = {
  first_rc30: 51,
  first_rc60: 50,
};

export const RC30_EDITION = {
  first: 35,
  second: 38,
  third: 42,
  fourth: 48,
  first_2024: 22,
  second_2024: 31,
  third_2024: 67,
  first_2025: 10,
  second_2025: 49,
  third_2025: 69,
};

export const UM30_EDITION = {
  second: 49,
  first_2024: 20,
  second_2024: 29,
  second_2_2024: 44,
  third_2024: 65,
  first_2025: 18,
  second_2025: 48,
  third_2025: 70,
  first_2026: 87,
};

export const CM30_EDITION = {
  second: 54,
  first_2024: 21,
  second_2024: 30,
  third_2024: 66,
  first_2025: 16,
  second_2025: 47,
  third_2025: 71,
  first_2026: 88,
};

export const IUL30_EDITION = {
  second_2024: 34,
  third_2024: 68,
};

export const UNT30_EDITION = {
  third_2024: 75,
  first_2025: 15,
  second_2025: 46,
  third_2025: 72,
  first_2026: 86,
};

export const REGIONS = [
  {
    label: "Abruzzo",
    value: "abruzzo",
  },
  {
    label: "Basilicata",
    value: "basilicata",
  },
  {
    label: "Calabria",
    value: "calabria",
  },
  {
    label: "Campania",
    value: "campania",
  },
  {
    label: "Emilia-Romagna",
    value: "emilia romagna",
  },
  {
    label: "Friuli-Venezia Giulia",
    value: "friuli venezia giulia",
  },
  {
    label: "Lazio",
    value: "lazio",
  },
  {
    label: "Liguria",
    value: "liguria",
  },
  {
    label: "Lombardia",
    value: "lombardia",
  },
  {
    label: "Marche",
    value: "marche",
  },
  {
    label: "Molise",
    value: "molise",
  },
  {
    label: "Piemonte",
    value: "piemonte",
  },
  {
    label: "Puglia",
    value: "puglia",
  },
  {
    label: "Sardegna",
    value: "sardegna",
  },
  {
    label: "Sicilia",
    value: "sicilia",
  },
  {
    label: "Toscana",
    value: "toscana",
  },
  {
    label: "Trentino-Alto Adige/Südtirol",
    value: "trentino alto adige",
  },
  {
    label: "Umbria",
    value: "umbria",
  },
  {
    label: "Valle d'Aosta/Vallée d'Aoste",
    value: "valle d'aosta",
  },
  {
    label: "Veneto",
    value: "veneto",
  },
];

export const COMPETITION_CLASS_2024 = {
  "A-01": "Arte e immagine nell'istruzione secondaria di I e II grado",
  "A-02": "Design dei metalli, dell'oreficeria, delle pietre dure e delle gemme",
  "A-03": "Design della ceramica",
  "A-04": "Design del libro",
  "A-05": "Design del tessuto e della moda",
  "A-06": "Design del vetro",
  "A-07": "Discipline audiovisive",
  "A-08": "Discipline geometriche, architettura, design d'arredamento e scenotecnica",
  "A-09": "Discipline grafiche, pittoriche e scenografiche",
  "A-10": "Discipline grafico-pubblicitarie",
  "A-11": "Discipline letterarie e latino",
  "A-12": "Discipline letterarie negli istituti di istruzione secondaria di I grado e di II grado",
  "A-13": "Discipline letterarie, latino e greco",
  "A-14": "Discipline plastiche, scultoree e scenoplastiche",
  "A-15": "Discipline sanitarie",
  "A-16": "Disegno artistico e modellazione odontotecnica",
  "A-18": "Filosofia e Scienze umane",
  "A-19": "Filosofia e Storia",
  "A-20": "Fisica",
  "A-21": "Geografia",
  "AA22": "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (FRANCESE)",
  "AB22": "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (INGLESE)",
  "AC22": "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (SPAGNOLO)",
  "AD22": "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (TEDESCO)",
  "AE22": "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (RUSSO)",
  "AG22": "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (SLOVENO)",
  "AI22": "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (CINESE)",
  "AJ22": "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (GIAPPONESE)",
  "AL22": "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (ARABO)",
  "AN22": "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (PORTOGHESE)",
  "A-23": "Lingua italiana per discenti di lingua straniera (alloglotti)",
  "A-26": "Matematica",
  "A-27": "Matematica e Fisica",
  "A-28": "Matematica e scienze",
  "A-30": "Musica nell'istruzione secondaria di I e II grado",
  "A-31": "Scienze degli alimenti",
  "A-32": "Scienze della geologia e della mineralogia",
  "A-33": "Scienze e tecnologie aeronautiche",
  "A-34": "Scienze e tecnologie chimiche",
  "A-35": "Scienze e tecnologie della calzatura e della moda",
  "A-36": "Scienze e tecnologie della logistica",
  "A-37": "Scienze e tecnologie delle costruzioni, tecnologie e tecniche di rappresentazione grafica",
  "A-38": "Scienze e tecnologie delle costruzioni aeronautiche",
  "A-39": "Scienze e tecnologie delle costruzioni navali",
  "A-40": "Scienze e tecnologie elettriche ed elettroniche",
  "A-41": "Scienze e tecnologie informatiche",
  "A-42": "Scienze e tecnologie meccaniche",
  "A-43": "Scienze e tecnologie nautiche",
  "A-44": "Scienze e tecnologie tessili, dell'abbigliamento e della moda",
  "A-45": "Scienze economico-aziendali",
  "A-46": "Scienze giuridico-economiche",
  "A-47": "Scienze matematiche applicate",
  "A-48": "Scienze motorie e sportive nell'istruzione secondaria di I e II grado",
  "A-50": "Scienze naturali, chimiche e biologiche",
  "A-51": "Scienze, tecnologie e tecniche agrarie",
  "A-52": "Scienze, tecnologie e tecniche di produzioni animali",
  "A-53": "Storia della musica e della danza",
  "A-54": "Storia dell'arte",
  "AA55": "Strumento musicale nella scuola secondaria di II grado (Arpa)",
  "AA56": "Strumento musicale nella scuola secondaria di I grado (Arpa)",
  "AB55": "Strumento musicale nella scuola secondaria di II grado (Chitarra)",
  "AB56": "Strumento musicale nella scuola secondaria di I grado (Chitarra)",
  "AC55": "Strumento musicale nella scuola secondaria di II grado (Clarinetto)",
  "AC56": "Strumento musicale nella scuola secondaria di I grado (Clarinetto)",
  "AD55": "Strumento musicale nella scuola secondaria di II grado (Corno)",
  "AD56": "Strumento musicale nella scuola secondaria di I grado (Corno)",
  "AE55": "Strumento musicale nella scuola secondaria di II grado (Fagotto)",
  "AE56": "Strumento musicale nella scuola secondaria di I grado (Fagotto)",
  "AF55": "Strumento musicale nella scuola secondaria di II grado (Fisarmonica)",
  "AF56": "Strumento musicale nella scuola secondaria di I grado (Fisarmonica)",
  "AG55": "Strumento musicale nella scuola secondaria di II grado (Flauto Dolce)",
  "AG56": "Strumento musicale nella scuola secondaria di I grado (Flauto)",
  "AH55": "Strumento musicale nella scuola secondaria di II grado (Oboe)",
  "AH56": "Strumento musicale nella scuola secondaria di I grado (Oboe)",
  "AI55": "Strumento musicale nella scuola secondaria di II grado (Percussioni)",
  "AI56": "Strumento musicale nella scuola secondaria di I grado (Percussioni)",
  "AJ55": "Strumento musicale nella scuola secondaria di II grado (Pianoforte)",
  "AJ56": "Strumento musicale nella scuola secondaria di I grado (Pianoforte)",
  "AK55": "Strumento musicale nella scuola secondaria di II grado (Sassofono)",
  "AK56": "Strumento musicale nella scuola secondaria di I grado (Saxofono)",
  "AL55": "Strumento musicale nella scuola secondaria di II grado (Tromba)",
  "AL56": "Strumento musicale nella scuola secondaria di I grado (Tromba)",
  "AM55": "Strumento musicale nella scuola secondaria di II grado (Violino)",
  "AM56": "Strumento musicale nella scuola secondaria di I grado (Violino)",
  "AN55": "Strumento musicale nella scuola secondaria di II grado (Violoncello)",
  "AN56": "Strumento musicale nella scuola secondaria di I grado (Violoncello)",
  "AO55": "Canto",
  "AP55": "Contrabbasso",
  "AQ55": "Organo",
  "AR55": "Trombone",
  "AS55": "Viola",
  "AT55": "Basso Tuba",
  "AU55": "Clavicembalo",
  "AV55": "Mandolino",
  "AW55": "Flauto Traverso",
  "A-57": "Tecnica della danza classica",
  "A-58": "Tecnica della danza contemporanea",
  "A-59": "Tecniche di accompagnamento alla danza",
  "A-60": "Tecnologia nella scuola secondaria di I grado",
  "A-61": "Tecnologie e tecniche delle comunicazioni multimediali",
  "A-62": "Tecnologie e tecniche per la grafica",
  "A-63": "Tecnologie musicali",
  "A-64": "Teoria, analisi e composizione",
  "A-65": "Teoria e tecnica della comunicazione",
  "A-70": "Italiano negli istituti di istruzione secondaria di I e II grado con lingua di insegnamento slovena o bilingui del Friuli Venezia Giulia",
  "A-71":
    "Discipline letterarie negli istituti di istruzione secondaria di I e II grado con lingua di insegnamento slovena o bilingui del Friuli Venezia Giulia",
  "A-74": "Discipline letterarie e latino con lingua di insegnamento slovena",
  "A-75": "Discipline letterarie, latino e greco con lingua di insegnamento slovena",
  "A-77": "Lingua e cultura ladina, storia ed educazione civica, geografia, nella scuola secondaria di I grado con lingua di insegnamento ladina",
  "A-78": "Italiano (seconda lingua), storia ed educazione civica, geografia, nella scuola secondaria di I grado con lingua di insegnamento tedesca",
  "A-79": "Discipline letterarie (italiano seconda lingua) negli istituti di istruzione secondaria di II grado in lingua tedesca",
  "A-80":
    "Discipline letterarie negli istituti di istruzione secondaria di II grado in lingua tedesca e con lingua di insegnamento tedesca delle località ladine",
  "A-81": "Discipline letterarie e latino nei licei in lingua tedesca e con lingua di insegnamento, tedesca delle località ladine",
  "A-82": "Discipline letterarie, latino e greco nel liceo classico in lingua tedesca e con lingua di insegnamento tedesca delle località ladine",
  "A-83":
    "Discipline letterarie (tedesco seconda lingua) negli istituti di istruzione secondaria di II grado in lingua italiana della provincia di Bolzano",
  "A-84":
    "Tedesco (seconda lingua), storia ed educazione civica, geografia, nella scuola secondaria di I grado con lingua di insegnamento italiana della provincia di Bolzano",
  "A-85": "Tedesco storia ed educazione civica, geografia, nella scuola secondaria di I grado in lingua tedesca e con lingua di insegnamento tedesca",
  "B-02": "Conversazione in lingua straniera",
  "B-03": "Laboratori di Fisica",
  "B-04": "Laboratori di liuteria",
  "B-05": "Laboratorio di logistica",
  "B-06": "Laboratorio di odontotecnica",
  "B-07": "Laboratorio di ottica",
  "B-08": "Laboratori di produzioni industriali ed artigianali della ceramica",
  "B-09": "Laboratori di scienze e tecnologie aeronautiche",
  "B-10": "Laboratori di scienze e tecnologie delle costruzioni aeronautiche",
  "B-11": "Laboratori di scienze e tecnologie agrarie",
  "B-12": "Laboratori di scienze e tecnologie chimiche e microbiologiche",
  "B-13": "Laboratori di scienze e tecnologie della calzatura e della moda",
  "B-14": "Laboratori di scienze e tecnologie delle costruzioni",
  "B-15": "Laboratori di scienze e tecnologie elettriche ed elettroniche",
  "B-16": "Laboratori di scienze e tecnologie informatiche",
  "B-17": "Laboratori di scienze e tecnologie meccaniche",
  "B-18": "Laboratori di scienze e tecnologie tessili, dell'abbigliamento e della moda",
  "B-19": "Laboratori di servizi di ricettività alberghiera",
  "B-20": "Laboratori di servizi enogastronomici, settore cucina",
  "B-21": "Laboratori di servizi enogastronomici, settore sala e vendita",
  "B-22": "Laboratori di tecnologie e tecniche delle comunicazioni multimediali",
  "B-23": "Laboratori per i servizi socio-sanitari",
  "B-24": "Laboratorio di scienze e tecnologie nautiche",

  "B-26": "Laboratorio di tecnologie del legno",
  "B-27": "Laboratorio di tecnologie del marmo",
  "B-28": "Laboratorio di tecnologie orafe",

};

export const COMPETITION_CLASS_TITLE_BEFORE2025 = {
  A001: "Arte e immagine nella scuola secondaria di I grado",
  A011: "Discipline Letterarie e Latino",
  A012: "Discipline Letterarie negli Istituti di Istruzione Secondaria di II Grado",
  A015: "Discipline sanitarie",
  A017: "Disegno e storia dell'arte negli istituti di istruzione secondaria di II grado",
  A018: "Filosofia e Scienze umane",
  A019: "Filosofia e Storia ",
  A020: "Fisica",
  A021: "Geografia",
  A022: "Italiano, Storia, Geografia nella Scuola Secondaria di I Grado",
  A026: "Matematica",
  A027: "Matematica e Fisica",
  A028: "Matematica e Scienze",
  A030: "Musica nella scuola secondaria di I grado",
  A031: "Scienze degli alimenti",
  A034: "Scienze e tecnologie chimiche",
  A037: "Scienze e tecnologie delle costruzioni, tecnologie e tecniche di rappresentazione grafica",
  A040: "Scienze e tecnologie elettriche ed elettroniche",
  A041: "Scienze e tecnologie informatiche",
  A042: "Scienze e tecnologie meccaniche",
  A045: "Scienze Economico-Aziendali",
  A046: "Scienze Giuridico-Economiche",
  A047: "Scienze matematiche applicate",
  A048: "Scienze Motorie e Sportive negli Istituti di Istruzione Secondaria di II Grado",
  A049: "Scienze Motorie e Sportive nella Scuola Secondaria di I Grado",
  A050: "Scienze naturali, chimiche e biologiche",
  A051: "Scienze, tecnologie e tecniche agrarie",
  A053: "Storia della musica",
  A054: "Storia dell'Arte",
  A059: "Tecniche di accompagnamento alla danza e teoria e pratica musicale per la danza",
  A060: "Tecnologia scuola secondaria di primo grado",
  AA22: "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (FRANCESE)",
  AB22: "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (INGLESE)",
  AC22: "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (SPAGNOLO)",
  AA24: "Lingue e Culture Straniere negli Istituti di Istruzione di II Grado (Francese)",
  AA25: "Seconda Lingua Comunitaria nella Scuola Secondaria I Grado (Francese)",
  AB24: "Lingue e Culture Straniere negli Istituti di Istruzione di II Grado (Inglese)",
  AB25: "Lingua Inglese e Seconda Lingua Comunitaria nella Scuola Secondaria I Grado (Inglese)",
  AB56: "Strumento musicale nella scuola secondaria di I grado(Chitarra)",
  AC55: "Clarinetto",
  AC56: "Strumento musicale nella scuola secondaria di I grado: Clarinetto",
  AG56: "Strumento musicale nella scuola secondaria di I grado: Flauto",
  AJ55: "Pianoforte",
  AJ56: "Strumento musicale nella scuola secondaria di I grado: Pianoforte",
  AK56: "Strumento musicale nella scuola secondaria di I Grado: Saxofono",
  AL55: "Tromba",
  AL56: "Strumento musicale nella scuola secondaria di I grado: Tromba",
  AM55: "Violino",
  AM56: "Strumento musicale nella scuola secondaria di I grado - Violino",
  AN55: "Violoncello",
  AO55: "Canto",
  B003: "Laboratorio di Fisica",
  B012: "Laboratori di scienze e tecnologie chimiche e microbiologiche",
  B016: "Laboratori di scienze e tecnologie informatiche",
  B018: "Laboratori di scienze e tecnologie tessili, dell'abbigliamento e della moda",
  B020: "Laboratori di servizi enogastronomici, settore cucina",
  B021: "Laboratori di servizi enogastronomici, settore sala e vendita",
  B022: "Laboratori di tecnologie e tecniche delle comunicazioni multimediali",
};

export const COMPETITION_CLASS_TITLE = {
  A001: "Disegno e storia dell’arte nell’istruzione secondaria di I e di II grado",
  A011: "Discipline Letterarie e Latino",
  A012: "Discipline letterarie nell’istruzione secondaria di I e II grado",
  A012_2_: "Discipline letterarie nell’istruzione secondaria di I e II grado",
  A015: "Discipline sanitarie",
  A017: "Disegno e storia dell'arte negli istituti di istruzione secondaria di II grado",
  A018: "Filosofia e Scienze umane",
  A019: "Filosofia e Storia ",
  A020: "Fisica",
  A021: "Geografia",
  A022: "Italiano, Storia, Geografia nella Scuola Secondaria di I Grado",
  A026: "Matematica",
  A027: "Matematica e Fisica",
  A028: "Matematica e Scienze",
  A030: "Musica nell’istruzione secondaria di I grado e di II grado",
  A030_2_: "Musica nell’istruzione secondaria di I grado e di II grado",
  A031: "Scienze degli alimenti",
  A034: "Scienze e tecnologie chimiche",
  A037: "Scienze e tecnologie delle costruzioni, tecnologie e tecniche di rappresentazione grafica",
  A040: "Scienze e tecnologie elettriche ed elettroniche",
  A041: "Scienze e tecnologie informatiche",
  A042: "Scienze e tecnologie meccaniche",
  A045: "Scienze Economico-Aziendali",
  A046: "Scienze Giuridico-Economiche",
  A047: "Scienze matematiche applicate",
  A048: "Scienze motorie e sportive nell'istruzione secondaria di I e II grado",
  A048_2_: "Scienze motorie e sportive nell'istruzione secondaria di I e II grado",
  A049: "Scienze Motorie e Sportive nella Scuola Secondaria di I Grado",
  A050: "Scienze naturali, chimiche e biologiche",
  A051: "Scienze, tecnologie e tecniche agrarie",
  A053: "Storia della musica",
  A054: "Storia dell'Arte",
  A059: "Tecniche di accompagnamento alla danza e teoria e pratica musicale per la danza",
  A060: "Tecnologia scuola secondaria di primo grado",
  AA22: "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (FRANCESE)",
  AB22: "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (INGLESE)",
  AC22: "Lingue e culture straniere nell'istruzione secondaria di I e di II grado (SPAGNOLO)",
  AA24: "Lingue e Culture Straniere negli Istituti di Istruzione di II Grado (Francese)",
  AA25: "Seconda Lingua Comunitaria nella Scuola Secondaria I Grado (Francese)",
  AB24: "Lingue e Culture Straniere negli Istituti di Istruzione di II Grado (Inglese)",
  AB25: "Lingua Inglese e Seconda Lingua Comunitaria nella Scuola Secondaria I Grado (Inglese)",
  AB56: "Strumento musicale nella scuola secondaria di I grado(Chitarra)",
  AC55: "Clarinetto",
  AC56: "Strumento musicale nella scuola secondaria di I grado: Clarinetto",
  AG56: "Strumento musicale nella scuola secondaria di I grado: Flauto",
  AJ55: "Pianoforte",
  AJ56: "Strumento musicale nella scuola secondaria di I grado: Pianoforte",
  AK56: "Strumento musicale nella scuola secondaria di I Grado: Saxofono",
  AL55: "Tromba",
  AL56: "Strumento musicale nella scuola secondaria di I grado: Tromba",
  AM55: "Violino",
  AM56: "Strumento musicale nella scuola secondaria di I grado - Violino",
  AN55: "Violoncello",
  AO55: "Canto",
  B003: "Laboratorio di Fisica",
  B012: "Laboratori di scienze e tecnologie chimiche e microbiologiche",
  B016: "Laboratori di scienze e tecnologie informatiche",
  B018: "Laboratori di scienze e tecnologie tessili, dell'abbigliamento e della moda",
  B020: "Laboratori di servizi enogastronomici, settore cucina",
  B021: "Laboratori di servizi enogastronomici, settore sala e vendita",
  B022: "Laboratori di tecnologie e tecniche delle comunicazioni multimediali",
  AH55: "Oboe",
  AH56: "Strumento musicale nella scuola secondaria di I grado - Oboe",
  AD55: "Corno",
  AD56: "Strumento musicale nella scuola secondaria di I grado - Corno",
  AF55: "Fisarmonica",
  AF56: "Strumento musicale nella scuola secondaria di I grado - Fisarmonica",
  AI55: "Percussioni",
  AI56: "Strumento musicale nella scuola secondaria di I grado - Percussioni",
  AB55: "Chitarra",
  AN56: "Strumento musicale nella scuola secondaria di I grado - Violoncello",
  A013: "Discipline letterarie, latino e greco",
  A023: "Lingua italiana per discenti di lingua straniera (alloglotti)",

};

export const COMPETITION_CLASS_GROUPS = {
  A001: ["A001", "A017"],
  A012: ["A012", "A022"],
  AB22: ["AB22", "AB24", "AB25"],
  AA22: ["AA22", "AA24", "AA25"],
  AC22: ["AC22", "AC24", "AC25"],
  A048: ["A048", "A049"],
};

export const SITE_CONFIG = {
  EXAM_WRITTEN_HOUR: "EXAM_WRITTEN_HOUR",
};

export const COURSE_STATUS = {
  ACTIVE: "active",
  COMPLETED: "completed",
  RETIRED: "retired",
  DELETED: "deleted",
};

export const USER_ROLES = {
  STUDENT: "student",
  ADMIN: "admin",
  EDITOR: "editor",
  REVISOR: "revisor",
  ADMIN_REVISOR: "admin_revisor",
  MANAGER: "manager",
  STEWARD: "steward",
  SEGRETERIA: "segreteria",
  SEGRETERIA_IUL: "segreteria_iul",
};

export const PRESET_METADATA_QUIZ = [
  {
    label: "Test Intermedio",
    preset: `{
            "repeat": true, 
            "attempts": 0, 
            "mandatory": true,
            "storable": false,
            "dnd": false,
            "toMergeQuestions": false,
            "constraints": {
                "duration": 0,
                "isPaymentOK": false
            },
            "feedbackFinal": {
              "brief": false, 
              "detail": true,
              "onlyAccepted": false,
              "hideOutComeAnswer": false,
              "isWordCount": false,
              "autoCorrection": false,
              "reloadLastAttempt": false,
              "showAnsOnAttempt": 0
            }, 
            "feedbackAnswer": true
        }`,
  },
  {
    label: "Test Intermedio da Deposito Domande",
    preset: `{
            "repeat": true, 
            "attempts": 0, 
            "mandatory": true,
            "storable": false,
            "dnd": false,
            "toMergeQuestions": false,
            "repository": [
                {
                    "name": "[inserisci_il_nome_della_repo]",
                    "questions": '[insersci_quante_domande_(int)]'
                }
            ],
            "constraints": {
                "duration": 0,
                "isPaymentOK": false
            },
            "feedbackFinal": {
                "brief": false, 
                "detail": true,
                "onlyAccepted": false,
                "hideOutComeAnswer": false,
                "isWordCount": false,
                "autoCorrection": false,
                "reloadLastAttempt": false,
                "showAnsOnAttempt": 0
            }, 
            "feedbackAnswer": true
        }`,
  },
  {
    label: "Prova Finale",
    preset: `{
            "repeat": false, 
            "attempts": 0, 
            "mandatory": false,
            "storable": true,
            "dnd": false,
            "toMergeQuestions": false,
            "constraints": {
                "duration": 0,
                "isPaymentOK": false
            },
            "feedbackFinal": {
                "brief": true, 
                "detail": false,
                "onlyAccepted": false,
                "hideOutComeAnswer": false,
                "isWordCount": false,
                "autoCorrection": false,
                "reloadLastAttempt": false,
                "showAnsOnAttempt": 0
            }, 
            "feedbackAnswer": false
        }`,
  },
  {
    label: "Prove di Profitto da Deposito Domande",
    preset: `{
            "repeat": false,
            "attempts": 1,
            "duration": 20,
            "mandatory": false,
            "storable": true,
            "dnd": false,
            "toMergeQuestions": false,
            "loseFocus": true,
            "code": "[inserisci_il_codice_insegnamento]",
            "repository": [
                {
                    "name": "[inserisci_il_nome_della_repo]",
                    "questions": '[insersci_quante_domande_(int)]'
                },
                {
                    "name": "[inserisci_il_nome_della_repo]",
                    "questions": '[insersci_quante_domande_(int)]'
                }
            ],
            "constraints": {
                "duration": 0,
                "isPaymentOK": true
            },
            "feedbackFinal": {
                "brief": false,
                "detail": false,
                "onlyAccepted": true,
                "hideOutComeAnswer": false,
                "isWordCount": false,
                "autoCorrection": false,
                "reloadLastAttempt": false,
                "showAnsOnAttempt": 0
            },
            "feedbackAnswer": false
        }`,
  },
  {
    label: "Test Inglese",
    preset: `{
            "repeat": true, 
            "attempts": 0, 
            "mandatory": true,
            "storable": true,
            "dnd": false,
            "toMergeQuestions": false,
            "toMergeReview": false,
            "constraints": {
                "duration": -1,
                "isPaymentOK": false
            },
            "lang": "en",
            "hideLabel": true,
            "feedbackFinal": {
                "brief": false, 
                "detail": true,
                "onlyAccepted": false,
                "hideOutComeAnswer": true,
                "isWordCount": true,
                "autoCorrection": true,
                "reloadLastAttempt": true,
                "showAnsOnAttempt": 2
            }, 
            "feedbackAnswer": true
        }`,
  },
  {
    label: "Test Inglese (DnD)",
    preset: `{
            "repeat": true, 
            "attempts": 0, 
            "mandatory": true,
            "storable": true,
            "dnd": true,
            "toMergeQuestions": false,
            "toMergeReview": false,
            "constraints": {
                "duration": -1,
                "isPaymentOK": false
            },
            "lang": "en",
            "hideLabel": true,
            "feedbackFinal": {
                "brief": false, 
                "detail": true,
                "onlyAccepted": false,
                "hideOutComeAnswer": true,
                "isWordCount": true,
                "autoCorrection": true,
                "reloadLastAttempt": true,
                "showAnsOnAttempt": 2
            }, 
            "feedbackAnswer": true
        }`,
  },
];

export const ACCOUNT_WEBEX = {
  list: [
    { label: "Seleziona AccountWebex", value: "" },
    { label: "Aula1", value: "aula1" },
    { label: "Aula2", value: "aula2" },
    { label: "Aula3", value: "aula3" },
    { label: "Aula4", value: "aula4" },
    { label: "Aula5", value: "aula5" },
    { label: "Aula6", value: "aula6" },
    { label: "Aula7", value: "aula7" },
    { label: "Aula8", value: "aula8" },
    { label: "Aula9", value: "aula9" },
    { label: "Aula10", value: "aula10" },
    { label: "Aula11", value: "aula11" },
    { label: "Aula12", value: "aula12" },
    { label: "Aula13", value: "aula13" },
    { label: "Aula14", value: "aula14" },
    { label: "Aula15", value: "aula15" },
    { label: "Aula16", value: "aula16" },
    { label: "Aula17", value: "aula17" },
    { label: "Aula18", value: "aula18" },
    { label: "Aula19", value: "aula19" },
    { label: "Aula20", value: "aula20" },
    { label: "Aula21", value: "aula21" },
    { label: "Aula22", value: "aula22" },
    { label: "Aula23", value: "aula23" },
    { label: "Aula24", value: "aula24" },
    { label: "Aula25", value: "aula25" },
    { label: "Aula26", value: "aula26" },
    { label: "Aula27", value: "aula27" },
    { label: "Aula28", value: "aula28" },
    { label: "Aula29", value: "aula29" },
    { label: "Aula30", value: "aula30" },
    { label: "Aula31", value: "aula31" },
    { label: "Aula32", value: "aula32" },
    { label: "Aula33", value: "aula33" },
    { label: "Aula34", value: "aula34" },
    { label: "Aula35", value: "aula35" },
    { label: "Aula36", value: "aula36" },
    { label: "Aula37", value: "aula37" },
    { label: "Aula38", value: "aula38" },
    { label: "Aula39", value: "aula39" },
    { label: "Aula40", value: "aula40" },
    { label: "Aula3000", value: "aula3000" },
    { label: "Aula5000", value: "aula5000" },
    { label: "Aula10000", value: "aula10000" },
  ],
};

export const LABEL_UNIVERSITY = {
  iul: "Università IUL",
  unicamillus: "Università Unicamillus",
  unitelma: "Università Unitelma Sapienza",
  reggio: 'Università per Stranieri "Dante Alighieri" di Reggio Calabria',
};

export const CURRENT_EDITION_BANDO = {
  iul: 0,
  unicamillus: 0,
  unitelma: 0,
  reggio: 4,
};

export const QUALIFICATION_CODE = {
  LAU_VO: "Laurea Vecchio Ordinamento",
  LAU_02_509: "Laurea DM 509/1999 specialistica biennale",
  LAU_CU_509: "Laurea DM 509/1999 specialistica a ciclo unico",
  LAU_02_270: "Laurea DM 270/2004 magistrale biennale",
  LAU_CU_270: "Laurea DM 270/2004 magistrale a ciclo unico",
  AFAM: "Diploma accademico di II livello rilasciato dalle istituzioni AFAM per l'insegnamento dell'Educazione musicale o dello strumento",
};

export const TFA_COURSETYPE = {
  TFASOSTEGNOUNICAMILLUS: "TFASOSTEGNOUNICAMILLUS",
};
